<div class="d-flex ion-justify-content-center mt-md"
     *ngIf="isLoading; else contentDiv;">
  <ion-spinner></ion-spinner>
</div>

<ng-template #contentDiv>
  <div class="content-spacing" [innerHTML]="content"></div>
</ng-template>
